var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "property-base",
    {
      attrs: {
        label: _vm.resource("JourneyBuilder_FilterSettings_SelectSteamCampaign")
      }
    },
    [
      _c(
        "input-group",
        { attrs: { icon: "fas fa-phone" } },
        [
          _c(
            "v-select",
            {
              staticClass: "form-control",
              attrs: {
                options: _vm.options,
                clearable: false,
                searchable: "",
                filterable: "",
                taggable: "",
                "close-on-select": ""
              },
              model: {
                value: _vm.newValue,
                callback: function($$v) {
                  _vm.newValue = $$v
                },
                expression: "newValue"
              }
            },
            [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }